import { styled } from "styled-components";
import { Container, MainContainer, PreText } from "../containers/PageContainer";
import { useMenu } from "../hooks/useMenu";
import { useScroll } from "../hooks/useScroll";
import { StyledH1 } from "../StyledComponents";

export const Contacts: React.FC = () => {
  const { isScrolled } = useScroll();
  const { isMenuClosed } = useMenu();

  return (
    <Container $isScrolled={isScrolled} $isMenuClosed={isMenuClosed}>
      <StyledH1>Kontaktní informace</StyledH1>
      <PreText>
        V případě zájmu o&nbsp;naše výrobky či&nbsp;zakázkovou výrobu nás prosím
        neváhejte kontaktovat.
      </PreText>
      <ContactMainContainer>
        <ContactContainer>
          <ContactH2>Sídlo společnosti</ContactH2>
          <ContactBoxContainer>
            <ContactText>
              <strong>Tomáš Frajvald</strong>
              <p>
                Líšnice 227 <br /> PSČ 561 84
              </p>
              <p>
                e-mail: fama@fama.cz <br />
                tel: +420 734 308 772
              </p>
              <p>
                Jak se k nám dostanete?{" "}
                <NavLink
                  target="_blank"
                  href="https://mapy.com/cs/turisticka?source=firm&id=431665&ds=1&x=16.5075798&y=50.0822230&z=18"
                >
                  Mapy.com
                </NavLink>
              </p>
            </ContactText>
          </ContactBoxContainer>
        </ContactContainer>
      </ContactMainContainer>
    </Container>
  );
};

const ContactH2 = styled.h2`
  font-size: 1.5em;
  margin-bottom: 10px;
`;

const ContactMainContainer = styled(MainContainer)`
  flex-direction: column;
  align-items: center;
`;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContactBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px;
  padding: 20px 20px 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const ContactImage = styled.img`
  width: 200px;
  height: 200px;
  margin-right: 10px;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

const ContactText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const NavLink = styled.a`
  color: rgb(52 181 75);
  text-decoration: none;
  &:hover {
    color: #5e8f20;
  }
`;
